import React, { useState } from "react";
import "./building_page.css";
import ReactGA from "react-ga4";

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    budget: "",
    date: "",
    time: "",
    message: "",
    interior: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "",
    budget: "",
    date: "",
    time: "",
    message: "",
    interior: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: "" }));
  };

  const validateField = (field, value) => {
    switch (field) {
      case "firstName":
        return value ? "" : "First name is required";
      case "lastName":
        return value ? "" : "Last name is required";
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return value
          ? emailRegex.test(value)
            ? ""
            : "Invalid email address"
          : "Email is required";
      case "role":
        return value ? "" : "Role is required";
      case "budget":
        return value ? "" : "Budget is required";
      case "interior":
        return value ? "" : "Interior size is required";
      case "phoneNumber":
        return value ? "" : "Phone number is required";
      default:
        return "";
    }
  };

  const validateForm = () => {
    let valid = true;
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      setErrors((prevErrors) => ({ ...prevErrors, [field]: error }));
      if (error) valid = false;
    });
    console.log(valid);
    return valid;
  };
  const emailTemplate = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>New Union Center Lead!</title>
    <style>
      a { font-style: italic; font-weight: bold; color: black !important; }
    </style>
  </head>
  <body style="font-family: Arial, sans-serif; margin: 0; padding: 0;">
    <div style="width: 100%; max-width: 750px; margin: 0 auto; padding: 20px;">
      <div style="text-align: center; font-size: 33px; color: #333; margin-bottom:40px;">New Union Center Lead!</div>
      <div style="background-color: #F3EBDD; border-radius: 20px; width:100%; padding: 20px">
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">First Name: ${formData.firstName}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Last Name: ${formData.lastName}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Phone Number: ${formData.phoneNumber}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Email: ${formData.email}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Budget: ${formData.budget}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Interior: ${formData.interior}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Role: ${formData.role}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Date Available: ${formData.date}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Time Available: ${formData.time}</div>
        <div style="font-size: 18px; color: #666; margin-top:5px; margin-bottom:5px;">Comment: ${formData.message}</div>
      </div>
      <div style="padding: 35px 0px; width: 100%;">
        <div style="width: 100%; max-width: 400px; margin: 0 auto;">
          <div style="font-size:14px; color: #BC9067; text-align: center"> This is a new lead from 3716union.com</div>
        </div>
      </div>
    </div>
  </body>
  </html>
`;
  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitSuccess(false);

    if (validateForm()) {
      setIsSubmitting(true);
      try {
        // Track form submission attempt
        ReactGA.event({
          category: "Form",
          action: "Submit",
          label: "Contact Form",
        });

        const form = new FormData();
        form.append("from", "onboarding@resend.dev");
        form.append("to", "unioncenter3716@gmail.com");
        form.append("subject", "New Union Center Lead!");
        form.append("html", emailTemplate);

        const response = await fetch(
          `https://union-track-server.vercel.app/api/send`,
          {
            method: "POST",
            body: form,
          }
        );

        if (!response.ok) throw new Error("Network response was not ok");
        // Track successful submission
        ReactGA.event({
          category: "Form",
          action: "Submit Success",
          label: "Contact Form",
        });
        setSubmitSuccess(true);
        // Reset form after successful submission
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          role: "",
          budget: "",
          date: "",
          time: "",
          message: "",
          interior: "",
        });
      } catch (error) {
        // Track submission error
        ReactGA.event({
          category: "Form",
          action: "Submit Error",
          label: "Contact Form",
          value: error.message,
        });
        window.alert("Network Error");
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  return (
    <div className="flex w-full flex-col  pt-40 bg-[#F0EDE8]">
      <section className="md:flex w-full">
        <div className="w-full flex flex-col bg-[#F0EDE8] -mt-4 md:-mt-0">
          <div className="w-full max-w-[700px] mx-auto md:pt-[60px] pt-10 md:text-center px-4">
            <p className="text-[#7e6140] text-4xl md:text-5xl font-normal leading-snug pb-1 md:pb-3">
              Contact Us
            </p>
            <p>
              Have a question or want to schedule a viewing? Send us a message!
            </p>
          </div>
          <div className="w-full lg:flex max-w-[600px] -mt-5 mx-auto">
            <div className="w-full">
              <div className="w-full p-2 px-3">
                <div className="w-full lg:flex lg:space-x-6">
                  <div className="w-full relative mt-4 sm:mb-0">
                    <div className="w-full flex justify-center item-center  flex-col">
                      <input
                        className="rounded-md bg-white border-[2px] py-2 px-3  w-full  border-[#7d6140ff]"
                        placeholder="First Name*"
                        type="text"
                        id="first_name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      ></input>
                      {errors.firstName && (
                        <p className="text-[#ff0000] absolute top-12 text-sm">
                          {errors.firstName}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-full relative sm:mt-4 mt-4  sm:mb-0">
                    <div className="w-full flex justify-center item-center  flex-col">
                      <input
                        className="rounded-md bg-white border-[2px] py-2 px-3  w-full  border-[#7d6140ff]"
                        placeholder="Last Name*"
                        type="text"
                        id="last_name"
                        value={formData.lastName}
                        name="lastName"
                        onChange={handleChange}
                      ></input>
                      {errors.lastName && (
                        <p className="text-[#ff0000] absolute top-12 text-sm">
                          {errors.lastName}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w-full lg:my-6 space-x-3 my-4 sm:my-3 relative">
                  <div className="w-full flex justify-center item-center  flex-col">
                    <input
                      className="rounded-md bg-white border-[2px] py-2 px-3  w-full  border-[#7d6140ff]"
                      placeholder="Email*"
                      type="text"
                      id="email"
                      value={formData.email}
                      name="email"
                      onChange={handleChange}
                    ></input>
                    {errors.email && (
                      <p className="text-[#ff0000] absolute top-12 text-sm">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:my-6 space-x-3 my-4 sm:my-3 relative">
                  <div className="w-full flex justify-center item-center  flex-col">
                    <input
                      className="rounded-md bg-white border-[2px] py-2 px-3  w-full  border-[#7d6140ff]"
                      placeholder="Phone Number*"
                      type="text"
                      id="phone"
                      value={formData.phoneNumber}
                      name="phoneNumber"
                      onChange={handleChange}
                    ></input>
                    {errors.phoneNumber && (
                      <p className="text-[#ff0000] absolute top-12 text-sm">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:my-6 space-x-3 my-4 sm:my-3 relative">
                  <div className="w-full flex flex-col">
                    <select
                      className="bg-white appearance-none border-[2px] py-2 w-full rounded-md sm:w-full px-3  border-[#7d6140ff]"
                      id="role"
                      value={formData.role}
                      name="role"
                      onChange={handleChange}
                    >
                      <option value="">Select Role*</option>
                      <option value="Buyer">Buyer</option>
                      <option value="Broker">Broker</option>
                    </select>
                    {errors.role && (
                      <p className="text-[#ff0000] absolute top-12 text-sm">
                        {errors.role}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:my-6 space-x-3 my-4 sm:my-3 relative rounded">
                  <div className="w-full flex flex-col">
                    <select
                      className="bg-white appearance-none border-[2px] py-2 w-full rounded-md sm:w-full px-3  border-[#7d6140ff]"
                      id="interior"
                      value={formData.interior}
                      name="interior"
                      onChange={handleChange}
                    >
                      <option value="">Choose Size*</option>
                      <option value="400-600 Sqft">400-600 SQFT</option>
                      <option value="600-800 SqFt">600-800 SQFT</option>
                      <option value="800-1200 SqFt">800-1200 SQFT</option>
                      <option value="1200-1600 SqFt">1200-1600 SQFT</option>
                      <option value="1600+ SqFt">1600+ SQFT</option>
                    </select>
                    {errors.interior && (
                      <p className="text-[#ff0000] absolute top-12 text-sm">
                        {errors.interior}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:mt-6 space-x-3 my-4 sm:my-3  relative rounded">
                  <div className="w-full flex   justify-center flex-col">
                    <select
                      className="bg-white appearance-none border-[2px] py-2 w-full rounded-md sm:w-full px-3  border-[#7d6140ff]"
                      id="price"
                      value={formData.budget}
                      name="budget"
                      onChange={handleChange}
                    >
                      <option value="">Select Your Budget*</option>
                      <option value="$700K-$900K">$700K-$900K</option>
                      <option value="$900K-$1.1M">$900K-$1.1M</option>
                      <option value="$1.1M-$1.3M">$1.1M-$1.3M</option>
                      <option value="$1.3M+">$1.3M+</option>
                    </select>
                    {errors.budget && (
                      <p className="text-[#ff0000] absolute top-12 text-sm">
                        {errors.budget}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full -mt-2 flex space-x-6">
                  <div className="w-full relative ">
                    <label className="px-2">Select Available Date</label>
                    <div className="w-full flex justify-center item-center  flex-col">
                      <input
                        className="rounded-md bg-white border-[2px]   w-full appearance-none h-11   px-2 py-2 border-[#7d6140ff]"
                        placeholder="Date*"
                        type="date"
                        id="date"
                        value={formData.date}
                        name="date"
                        onChange={handleChange}
                      ></input>
                    </div>
                  </div>
                  <div className="w-full relative ">
                    <label className="px-2">Select Available Time</label>
                    <div className="w-full flex justify-center item-center  flex-col">
                      <input
                        className="rounded-md bg-white border-[2px]  w-full appearance-none h-11  px-2 py-2 border-[#7d6140ff]"
                        placeholder="Time*"
                        type="time"
                        id="time"
                        value={formData.time}
                        name="time"
                        onChange={handleChange}
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <textarea
                    placeholder="Message"
                    id="message"
                    className="focus-visible:outline-none rounded-xl w-full  bg-white min-h-[100px] border-[2px] p-2 px-3 border-[#7d6140ff]"
                    value={formData.message}
                    name="message"
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="pt-6 pb-[100px] text-center w-full flex flex-col items-center">
                  <button
                    className={`text-white bg-[#7d6140ff] hover:bg-[#000000] duration-1000 hover:text-main-bg rounded-full px-8 py-3 text-xl ${
                      isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>

                  {submitSuccess && (
                    <div className="mt-4 text-[#4F7942] font-medium">
                      Your form was submitted successfully! We will contact you
                      shortly!
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-background"></div>
      <div className="w-full text-[#00000] text-base  bg-white"></div>
    </div>
  );
}
